import React from 'react';
import styled from 'styled-components';

import { Box } from 'Components/Base';

import Sidebar from './Containers/Sidebar';
import Dashboard from './Containers/Dashboard';
import { SIDEBAR_WIDTH, SIDEBAR_MAX_WIDTH } from './constants';

const ShadowSidebar = styled(Sidebar)`
  position: fixed;
  box-shadow: 0px 4px 24px rgba(17, 17, 26, 0.025), 0px 4px 16px rgba(17, 17, 26, 0.05);
  min-height: 100vh;
`;

const MyDashboard = styled(Box)`
  position: relative;
`;

const FixedSidebarMyCourses = () => {
  return (
    <>
      <ShadowSidebar
        width={SIDEBAR_WIDTH}
        maxWidth={SIDEBAR_MAX_WIDTH}
        display={{ _: 'none', lg: 'block' }}
      />
      <MyDashboard ml={{ _: 0, lg: `min(${SIDEBAR_WIDTH},${SIDEBAR_MAX_WIDTH})` }}>
        <Dashboard />
      </MyDashboard>
    </>
  );
};

export default FixedSidebarMyCourses;
